<template>
<v-card v-bind="$attrs" tile flat v-if="product" :color="dark? 'black' : 'background'" 
:style="'min-height:50vh;max-width:' + this.$config.page.width + 'px'"
>
<v-system-bar color="#FFFFFF" fixed v-if="platform=='ios'" height="33" app class="pa-0">
      </v-system-bar>
   <v-toolbar tile ref="headeritem"
    :dark="dark"
     fixed flat
     class="border-bottom"
     :class="{'pt-8' : platform=='ios'}"
     :height="'auto'"
  >
    <v-btn v-if="step > 0"  @click="step--" icon><v-icon>arrow_back_ios</v-icon></v-btn>
      
  <v-toolbar-title
      class="pl-0 do-wrap"  @click="step--" 
    >
    {{name}}<v-btn v-if="step > 0 && (product.favorite && step==steps-1)" small @click="step--" text color="primary">aanpassen</v-btn>
    </v-toolbar-title>
   
     <v-spacer></v-spacer>
     <!--v-btn icon @click="reset" v-if="isComplete && (product.volume || product.variation)" color="primary"><v-icon>edit</v-icon></v-btn-->
   <v-btn icon @click="close"><v-icon>close</v-icon></v-btn>
   </v-toolbar>
   
    <v-card-text class="pa-0 pt-3 fill-height" outlined :class="{'pb-10': fullscreen}">
        

      <v-img v-if="product.image" :src="product.image" max-height="200" contain></v-img>
    <v-card-subtitle v-if="product.description" v-html="descriptionHTML"></v-card-subtitle>
      <!--v-card-title :id="'P' + product._key" class="primary--text" v-if="!fullscreen"
      >{{ product.$name }}
      <v-spacer></v-spacer>
      <v-btn icon @click="close"><v-icon>close</v-icon></v-btn>
    </v-card-title-->
    <template v-if="focus"> 
         <v-card-title class="mt-3 pb-0 primary--text font-weight-light">Opmerking</v-card-title>
    <v-sheet class="mt-3 mb-10">
         <v-divider></v-divider>
            <v-textarea class="pl-3" ref="description" id="description"
                                                    v-model="description"
                                                    background-color="transparent"
                                                    flat
                                                    hide-details
                                                    :autofocus="focus"
                                                    :rows="3" full-width 
                                                    auto-grow
                                                    >
                                                </v-textarea>
                                                <v-divider></v-divider>
                                                </v-sheet>
    </template>
    <v-window v-model="step" ref="pages" v-else>
      <v-window-item v-if="product.volume">
        <v-card-title class="primary--text font-weight-light">Maak een keuze</v-card-title>
        <v-list class="pa-0">
            <template v-for="(vol, v) in product.volume">
              <v-divider :key="'d'+v"></v-divider>
              <v-list-item :key="v" @click="select(vol)" :class="{'primary' : volume && volume.name==vol.name}" :dark="volume && volume.name==vol.name">
                        <v-list-item-content>
                          <v-list-item-title>{{ vol.name }}</v-list-item-title>
                        </v-list-item-content>
                          <v-list-item-action v-if="vol.price > 0">
                          {{ vol.price | toCurrency }}
                          <!--v-list-item-action-text>+</v-list-item-action-text-->
                        </v-list-item-action>
                  </v-list-item>
            </template>
            <v-divider></v-divider>
          </v-list>
      </v-window-item>
    <v-window-item v-if="product.variation">
       <v-card-title class="primary--text font-weight-light">Maak een keuze</v-card-title>
      <v-list class="pa-0" >
        <template v-for="(vari, v) in product.variation">
          <v-divider :key="'vv'+v"></v-divider>
          <v-list-item :key="'ll' + v" @click="select(null,vari)" :class="{'primary' : vari == variation}" :dark="vari == variation">
                    <v-list-item-content>
                      <v-list-item-title>{{ vari }}</v-list-item-title>
                    </v-list-item-content>
                      <v-list-item-action>
                      {{ product.$amount | toCurrency }}
                      <!--v-list-item-action-text>+</v-list-item-action-text-->
                    </v-list-item-action>
               </v-list-item>
        </template>
        <v-divider></v-divider>
      </v-list>
      </v-window-item>
     <v-window-item v-if="required.length>0">
        <v-divider></v-divider>
            <template v-for="add in required">
            <include-select :key="`ii-${add.group}`"
                v-model="add.value" 
                :add="add"
                :list="getProducts(add.group, true)" 
                :show="5"
                :dark="dark"
                :product="product"
                :extra="false"
                @update="updateMe"
                @next="step++"
                ></include-select>
      </template>
      <v-divider></v-divider>
     <!--v-btn color="primary" depressed @click="step++" large class="pl-5 mt-4 float-right" :disabled="!isComplete"
          >Volgendess <v-icon>chevron_right</v-icon></v-btn
        -->
     </v-window-item>
    <v-window-item v-if="additions.length>0">
     
       <template v-for="(add,i) in additions">
            <v-divider :key="`ss-${i}`" class="mt-3"></v-divider>
           <include-select :key="`ii-${add.group}`" 
           @click="step = step-(add.min>0 ? 1 : 0)"
            v-model="add.value" 
            :add="add"
            :list="getProducts(add.group, false)" 
            :show="5"
            :dark="dark"
            :product="product"
            :extra="false"
            @update="updateMe"
            :required="add.min>0"
            
            >
            <span slot="extra" @click="step--" class="text-body-1 pr-3" v-if="add.min>0">{{add.value.map(i=>(i.count>1 ? i.count + 'x ' : '') + i.name).join(', ')}}</span>
            </include-select>
           <v-divider :key="`ss2-${add.group}`"></v-divider>
       </template>
       <v-card-title class="mt-3 pb-0 primary--text font-weight-light">Opmerking</v-card-title>
       <v-sheet class="mt-3 mb-10">
         <v-divider></v-divider>
            <v-textarea class="pl-3" ref="description" id="description"
                                                    v-model="description"
                                                    background-color="transparent"
                                                    flat
                                                    hide-details
                                                    :rows="3" full-width 
                                                    auto-grow
                                                    >
                                                </v-textarea>
                                                <v-divider></v-divider>
                                                </v-sheet>
       </v-window-item>
      <v-window-item v-if="extras.length>0">  
         <template v-for="(add,i) in extras">
            <v-divider :key="`ee-${add.group}`"></v-divider>
            <include-select
            :key="`iid-${add.group}`"
            v-model="extras[i]" 
            :list="getProducts(add.group, false)" 
            :show="5" :dark="dark"
            :product="product"
            :extra="true"
            @update="updateMe"
            ></include-select>
             <v-divider :key="`ee2-${add.group}`"></v-divider>
         </template>
        </v-window-item>
      </v-window>
    </v-card-text>
      <v-card-actions class="px-3 mt-5" ref="footer" :class="{'pb-6' : platform=='ios'}">
        <v-btn-toggle dense active-class="transparent">
          <v-btn
            @click="removeMe"
            v-if="quantity == 1"
            outlined
            style="min-width: 32px !important; width: 32px"
          >
            <v-icon color="grey">delete</v-icon>
          </v-btn>
          <v-btn
            @click="quantity--"
            v-else
            outlined
            style="min-width: 32px !important; width: 32px"
          >
            <v-icon>remove</v-icon>
          </v-btn>
          <v-btn
            outlined
            class="text-h6 font-weight-bold"
            style="min-width: 32px !important; width: 32px"
            >{{ quantity }}</v-btn
          >
          <v-btn
            @click="quantity++"
            outlined
            style="min-width: 32px !important; width: 32px"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-btn color="success" v-if="product._cart" depressed @click="saveCart" large class="white--text flex-grow-1">Opslaan ({{amount | toCurrency}})</v-btn>
        <v-btn color="success" v-else-if="step==steps-1 || steps==1" depressed @click="save" large :disabled="step<steps-1 || !isComplete"
          >Toevoegen ({{ totalAmount | toCurrency }})</v-btn
        >
        <v-btn depressed v-else large class="pl-5" @click="step++" :disabled="!isComplete">Volgende<v-icon class="ml-2">chevron_right</v-icon></v-btn>
      </v-card-actions>
    
    
  </v-card>
</template>
<script>
import productItem from "@/modules/productItem";
import IncludeSelect from '../components/IncludeSelect.vue'
export default {
  mixins: [productItem],
  components: {
    IncludeSelect
  },
  props: {
    value: {
      type: Object,
      default: function () {
        return null;
      },
    },
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    dark: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
     fullscreen: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
     focus: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
   data: () => ({
     step:0,
     steps: 0,
    include: [],
    extra: []
  }),
  computed: {
    descriptionHTML() {
      if (!this.product.description) return null
      let d = this.product.description
      d = d.split('- ').filter(s=>s).join('<br>- ')
      if (this.product.description.includes('- ')) d = '- ' + d
      d = d.split(';').filter(s=>s).join('<br>')
      return d
      
    },
    additions(){
       if (!this.product || !this.product.add) return []
       if (this.product._cart) return this.product.add.filter(a=>!a.extra && a.tab!='extra')// && //.filter(a=>!a.min > 0)
        return this.product.add//!a.extra && a.tab!='extra' && //.filter(a=>!a.min > 0)
    },
    totalAmount(){
      return this.amount + this.extraPrice(this.product)
    },
    extras(){
      return []
       if (!this.product || !this.product.add) return []
        return this.product.add.filter(a=>a.extra || a.tab=='extra')
    },
    required() {
      if (!this.product || !this.product.add) return [];
      return this.product.add.filter((a) => !a.extra && a.min > 0);
    },
    hasRequired(){
      if (!this.required) return false
       return this.required.filter((a) => a.value && a.value.length < a.min).length == 0
    },
    hasOptions() {
      if (this.product.variation) return true;
      return this.product.add && this.product.add.length > 0 ? true : false;
    },
    isValid() {
      let valid = true;
      let arr = this.product.add || [],
        include = this.include || [];
      arr
        .filter((a) => a.min || a.max)
        .map((a) => {
          let count = 0
          include.filter((i) => i.group == a.group).map(i=>count += i.count || i.quantity || i.$quantity || 1)
          if (a.value && count==0) a.value.map(i=>count += i.count || i.quantity || i.$quantity || 1)
          if (count < a.min || count > a.max) {
            if (count < a.min || a.min != a.max || a.min!=1) valid = false;
          }
        });
      return valid;
    },
    isFilled(){
      if (!this.product) return false;
      let valid = true;

      if (this.product.volume && this.product.volume.length > 0 && !this.volume)
        valid = false;
      if (
        this.product.variation &&
        this.product.variation.length > 0 &&
        !this.variation
      )
        valid = false;
      return valid
    },
    isComplete() {
      return this.isFilled && this.isValid;
    },
    deliver(){
        return this.$store.state.config.type == 'deliver'
    },
  },
  mounted() {
    
   this.init()
    //if (this.hasOptions) this.$emit("select", this.product);
  },
  watch: {
    quantity(value){
      if (value == 0) return this.removeMe()
      
    },
    step(value){
       // console.log('step',value )
       //console.log(this.additions)
    },
    volume(value){
      this.step = value ? 1 :  0
    },
    variation(value){
      if (value && this.step+1 < this.steps) return this.step++
    },
    hasRequired(value,old){
      //if (!old && value) return this.step++
    }
  },
  methods: {
    init(){
      //console.log('value', this.value)
      if (this.value._cart){
        if (this.value.$include) this.value.$include.map(i=>i.count== i.count || i.$quantity || 1)
        this.include = this.value.$include
        this.extra = this.value.$extra
        this.product = this.clone(this.loadProduct(this.value));
        this.product.$include = this.include
        //console.log('value', this.value)
      }else{
        this.product = this.loadProduct(this.clone(this.value));
        this.product.$quantity = this.value.$quantity || this.value.quantity || 1
        this.include = this.product.$include
        this.extra = this.product.$extra
      }
      
      //console.log(this.include)
      this.$nextTick(()=>{
        if (this.$refs.pages) this.steps = this.$refs.pages.$children.length
        if (this.product.favorite) this.step = this.steps-1
      })
    },
    select(volume, variation) {
      //this.product= this.setProduct(this.product);
      this.product = Object.assign(this.product, {
        $volume: volume || this.volume,
        $variation: variation || this.variation
      })
      if (!this.hasOptions) return this.save()
      this.product = this.setProduct(this.product);
      
    },
    save(){
      //return console.log(this.include)
      this.product = this.setProduct(this.product);
      this.product.$quantity = this.quantity
      
      //this.product.$include = []
      
      //if (this.product.$include) this.product.$include.map(i=>this.setProduct(i))
      if (this.product.$extra) this.product.$extra.filter(e=>e._single).map(extra=>this.product.$include.push(this.setProduct(extra)))
      //return console.log(this.product)
      //console.log(this.product.$include.map(i=>i.name).join(', '))
      //console.log(this.include.map(i=>i.name).join(', '))
      //return console.log(this.product.$subname, this.product.$subprice, this.product.$amount)
      //if (!this.isComplete) return false
      //return console.log(this.product)
      this.$emit("select", this.clone(this.product));
      if (this.product.$extra){
        this.product.$extra.filter(e=>!e._single).map(extra=> {
          let p = this.setProduct(this.clone(extra))
         // console.log(p)
          this.$emit('select', p)
        })
      }
      this.close()
    },
    saveCart(){
      this.product.$quantity = this.quantity
      this.product = this.setProduct(this.product)
      this.$emit("update", this.clone(this.product));
      this.close()
    },
    updateMe(){
      this.product.$include = this.includelist.map(p=>this.setProduct(p))
      this.product.$extra = this.extralist.map(p=>this.setProduct(p))
      this.product = this.setProduct(this.product)
    },
    getProducts(group, isNone, def) {
      let list = this.clone(
        this.list.filter((p) => group == p.group 
        //&& (this.isNone(p) === isNone || isNone)
        && (!def || def.includes(p.name))
      ));
      list.map(p=>p.none=this.isNone(p))
      return list.sort(this.sortByTypeSoldName);
    },
    isNone(item) {
      return this.$config.none.includes(item.name);
    },
    getConfig(add, key , def){
      let group = add.group.split('-')[0]
      let config = this._config('include',group.toLowerCase())
      if (!config[key])  return def
      let product = this.product, label = this.product.$name || group
      return eval('`' + config[key]+ '`')
    },
    removeMe(){
      this.product.$quantity = this.quantity
      this.$emit("remove",this.product);
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    }
  },
};
</script>
